<template>
    <div style="width: 260px;">
        <div class="box">
            <!-- 正式菜单 -->
            <el-scrollbar style="height: calc(100vh - 5.21%); background-color: rgb(92, 143, 239);">
                <el-menu
                    :default-active="$route.path"
                    @open="handleOpen"
                    @close="handleClose"
                    :router="true"
                    mode="vertical"
                    class="el-menu-vertical-demo"
                    background-color="#5C8FEF"
                    text-color="#F4F8FB"
                    :collapse="isCollapse"
                    :unique-opened="true"
                    active-text-color="#F4F8FB"
                >
                    <NavItem  v-for="(item,index) in menuList" :key="index" :model="item"></NavItem>
                </el-menu>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
    import NavItem from '@/pages/menu/menu_item';
    import list from '@/pages/mock/index';
    import { selMenuByLoginUser } from '@/api/api';

    export default {
        data() {
            return {
                menuList: [],
                isCollapse: false
            }
        },
        components: {
            NavItem
        },
        computed: {
			defaultActive: function(){
				return this.$route.path.replace('/', '');
			}
        },
        created() {
            this.ajaxMenu();
        },
        methods: {
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            //获取菜单
            async ajaxMenu(){
                selMenuByLoginUser().then( r => {
                    if( r.code === 0 ){
                        this.menuList = r.data;
						            //this.hideSubMenu(); // 隐藏“分成比例设置”子菜单
                    }
                } )

            },
			      // 隐藏“分成比例设置”子菜单
            hideSubMenu() {
                const financeMenu = this.menuList.find(item => item.name === '财务管理');
                if (financeMenu) {
                    financeMenu.children = financeMenu.children.filter(item => item.name !== '分成比例设置');
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .box {
        position: absolute;
        left: 0;
        // top: 7.21%;
        right: 0;
        width: 260px;
        height: 100%;
        overflow: hidden;
        // background:linear-gradient(0deg,rgba(83,133,228,1) 0%,rgba(92,143,239,1) 100%);
    }

    .el-menu-vertical-demo {
        min-height: 100%;

    }
    .el-menu .el-menu-item{
        background-color: #4b7ed5 !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/menu/menu.vue